import type { FaireProductEntity } from "../../entity_types/product";

export const p_8vfkj6hrkd: FaireProductEntity = {
  token: "p_8vfkj6hrkd",
  type: "product",
  name: "Strawberry Stress Ball",
  brandToken: "b_eee77ed8",
  brandName: "People I've Loved",
  imageUrl:
    "https://cdn.faire.com/fastly/4bb0a61908fe85a647d2cd66d7cb47e65ed808683e54e7eaf601a2d1f860a48b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0492ba59992aa13a6ffb6960f7c912c1ebebe9c390dada84eaab16a647b8702c.jpeg",
    "https://cdn.faire.com/fastly/8c85d54d15cbcaf43785ae651c70a8915c11ade7507ef0090cbbe96db04597c8.jpeg",
    "https://cdn.faire.com/fastly/4bb12a6a31867b103e857fbf863df7fa0993347b62ea07c826ab5ac7ea34e284.jpeg",
    "https://cdn.faire.com/fastly/37ff41e72a0a2e6493a0c6a50ab03c9b54b9d05ff8ce910dd3c955c69a572a1d.png",
    "https://cdn.faire.com/fastly/cd159cca9f627e2e481d71f316f496c150b40da74f49563776f7f3b1e84b96c3.png",
  ],
  priceDollars: 6,
  description:
    "Hold me when you're in a jam. Valid for all of life's sticky situations and bitter moments... also exists as a reminder that when you feel like shit, it is possible that you are just hungry. Have a snack, squeeze a little stress out between your palms. \n3 x 4 inches \n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:49.692Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
